import type { Comic, Banner } from "../types/comic";

export const genres = [
  "少年",
  "少女",
  "青年",
  "同人",
  "奇幻",
  "科幻",
  "恋爱",
  "动作",
];

export const statusOptions = [
  { value: "all", label: "全部状态" },
  { value: "serializing", label: "连载中" },
  { value: "completed", label: "已完结" },
];

export const sortOptions = [
  { value: "popular", label: "按人气" },
  { value: "updated", label: "按更新时间" },
  { value: "favorites", label: "按收藏量" },
];

export const banners: Banner[] = [
  {
    id: "b1",
    comicId: "1",
    title: "星海彼岸的旅人",
    subtitle: "穿越星河的漫长旅途，只为寻找那个失落的约定",
    image: "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20anime%20banner%20of%20a%20lone%20space%20traveler%20in%20a%20sleek%20silver%20suit%20standing%20on%20a%20cliff%20edge%20facing%20a%20vast%20glowing%20purple%20nebula%2C%20distant%20planets%20and%20streaming%20starlight%2C%20deep%20dark%20navy%20space%20background%20with%20warm%20orange%20rim%20light%2C%20dramatic%20high%20contrast%20lighting%2C%20highly%20detailed%20stylized%20manga%20illustration&width=1600&height=800&seq=jm-banner-01&orientation=landscape",
  },
  {
    id: "b2",
    comicId: "2",
    title: "剑舞长安",
    subtitle: "一剑一式，皆是长安城中最炽热的江湖传说",
    image: "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20anime%20banner%20of%20a%20young%20swordsman%20in%20flowing%20dark%20robes%20unsheathing%20a%20glowing%20blade%20amid%20falling%20orange%20autumn%20leaves%2C%20ancient%20Chinese%20city%20rooftops%20and%20lanterns%20behind%2C%20moody%20dark%20atmosphere%20with%20warm%20amber%20highlights%2C%20dramatic%20dynamic%20lighting%2C%20detailed%20stylized%20manga%20art&width=1600&height=800&seq=jm-banner-02&orientation=landscape",
  },
  {
    id: "b3",
    comicId: "4",
    title: "机械之心",
    subtitle: "当钢铁获得心跳，人类与机器的界限开始模糊",
    image: "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20anime%20banner%20of%20a%20female%20android%20with%20flowing%20silver%20hair%20and%20glowing%20chest%20core%20surrounded%20by%20floating%20mechanical%20parts%2C%20futuristic%20dark%20laboratory%20with%20teal%20and%20orange%20cables%2C%20moody%20low%20key%20lighting%20with%20strong%20contrast%2C%20highly%20detailed%20stylized%20sci-fi%20manga%20illustration&width=1600&height=800&seq=jm-banner-03&orientation=landscape",
  },
  {
    id: "b4",
    comicId: "8",
    title: "龙裔传说",
    subtitle: "远古血脉觉醒之日，整片大陆都将为之颤抖",
    image: "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20anime%20banner%20of%20a%20young%20dragon%20knight%20with%20glowing%20golden%20eyes%20raising%20a%20great%20spear%20against%20a%20colossal%20shadow%20dragon%2C%20stormy%20dark%20mountain%20landscape%20with%20lightning%2C%20dramatic%20amber%20and%20deep%20charcoal%20palette%2C%20epic%20fantasy%20cinematic%20lighting%2C%20detailed%20stylized%20manga%20art&width=1600&height=800&seq=jm-banner-04&orientation=landscape",
  },
];

export const readingPages = [
  "https://readdy.ai/api/search-image?query=Vertical%20black%20and%20white%20manga%20page%20panel%20showing%20a%20wide%20establishing%20shot%20of%20a%20futuristic%20city%20skyline%20at%20dusk%20with%20flying%20vehicles%2C%20detailed%20line%20art%20with%20screentone%20shading%2C%20dynamic%20perspective%2C%20clean%20printed%20comic%20page%20texture&width=900&height=1300&seq=jm-page-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Vertical%20black%20and%20white%20manga%20page%20panel%20close%20up%20of%20a%20determined%20young%20hero%20shouting%20with%20speed%20lines%20and%20impact%20effects%2C%20expressive%20faces%2C%20detailed%20ink%20line%20art%20and%20screentone%20texture%2C%20classic%20shonen%20action%20comic%20style&width=900&height=1300&seq=jm-page-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Vertical%20manga%20page%20panel%20of%20an%20emotional%20quiet%20moment%20between%20two%20characters%20under%20falling%20cherry%20blossoms%2C%20soft%20delicate%20line%20art%20with%20gentle%20screentone%20gradients%2C%20romantic%20shojo%20comic%20page%20texture&width=900&height=1300&seq=jm-page-03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Vertical%20manga%20page%20panel%20of%20a%20fierce%20sword%20clash%20between%20two%20warriors%20with%20sparks%20and%20energy%20trails%2C%20bold%20dynamic%20line%20art%2C%20heavy%20screentone%20shading%2C%20dramatic%20action%20comic%20page%20texture&width=900&height=1300&seq=jm-page-04&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Vertical%20manga%20page%20panel%20of%20a%20mysterious%20ancient%20forest%20with%20glowing%20spirits%20floating%20between%20tall%20trees%2C%20atmospheric%20detailed%20ink%20line%20art%20with%20screentone%20shadows%2C%20fantasy%20comic%20page%20texture&width=900&height=1300&seq=jm-page-05&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Vertical%20manga%20page%20panel%20of%20an%20epic%20double%20page%20spread%20battle%20scene%20with%20many%20characters%20charging%20forward%2C%20intricate%20crowd%20line%20art%20and%20screentone%20shading%2C%20grand%20cinematic%20manga%20composition&width=900&height=1300&seq=jm-page-06&orientation=portrait",
];

export const comics: Comic[] = [
  {
    id: "1",
    title: "星海彼岸的旅人",
    author: "林逸风",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20anime%20comic%20book%20cover%20illustration%20of%20a%20lone%20young%20space%20traveler%20in%20a%20sleek%20silver%20suit%20holding%20a%20glowing%20star%20compass%2C%20vast%20purple%20nebula%20and%20distant%20planets%20behind%2C%20deep%20dark%20navy%20space%20background%20with%20warm%20orange%20rim%20light%2C%20cinematic%20dramatic%20lighting%2C%20highly%20detailed%20stylized%20manga%20art%2C%20clean%20centered%20composition&width=600&height=800&seq=jm-cover-01&orientation=portrait",
    genres: ["科幻", "少年"],
    status: "serializing",
    description:
      "银河纪元 3120 年，少年凯在一次跃迁事故中与母舰失联，只带着一枚会发光的星图罗盘漂流于星海之间。为了找回失落的母星坐标，他踏上横跨数十个星系的漫长旅途，也一步步揭开宇宙暗流涌动的真相。",
    updatedAt: "2026-10-12",
    views: 1582340,
    favorites: 92450,
    rating: 9.6,
    chapters: [
      { id: "c1-1", number: 1, title: "星际启程", updatedAt: "2026-08-02" },
      { id: "c1-2", number: 2, title: "失联的母舰", updatedAt: "2026-08-09" },
      { id: "c1-3", number: 3, title: "星图罗盘", updatedAt: "2026-08-16" },
      { id: "c1-4", number: 4, title: "站台 7 号的陌生人", updatedAt: "2026-08-23" },
      { id: "c1-5", number: 5, title: "蓝色巨行星", updatedAt: "2026-08-30" },
      { id: "c1-6", number: 6, title: "跃迁陷阱", updatedAt: "2026-09-06" },
      { id: "c1-7", number: 7, title: "拾荒者同盟", updatedAt: "2026-09-13" },
      { id: "c1-8", number: 8, title: "废墟中的歌声", updatedAt: "2026-09-20" },
      { id: "c1-9", number: 9, title: "暗物质之海", updatedAt: "2026-09-27" },
      { id: "c1-10", number: 10, title: "母星的坐标", updatedAt: "2026-10-04" },
      { id: "c1-11", number: 11, title: "归途的代价", updatedAt: "2026-10-09" },
      { id: "c1-12", number: 12, title: "星海彼岸", updatedAt: "2026-10-12" },
    ],
  },
  {
    id: "2",
    title: "剑舞长安",
    author: "墨萧",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20anime%20comic%20book%20cover%20illustration%20of%20a%20young%20swordsman%20in%20flowing%20dark%20robes%20unsheathing%20a%20glowing%20blade%20amid%20falling%20orange%20autumn%20leaves%2C%20ancient%20Chinese%20Tang%20dynasty%20city%20rooftops%20and%20red%20lanterns%20behind%2C%20moody%20dark%20atmosphere%20with%20warm%20amber%20highlights%2C%20dramatic%20dynamic%20lighting%2C%20detailed%20stylized%20wuxia%20manga%20art&width=600&height=800&seq=jm-cover-02&orientation=portrait",
    genres: ["少年", "动作"],
    status: "serializing",
    description:
      "长安城最年轻的剑客谢无咎，为洗清师门冤屈只身入京。剑影飞舞之间，他卷入了一场横跨朝堂与江湖的惊天棋局，也用一剑一式写下了属于自己的江湖传说。",
    updatedAt: "2026-10-11",
    views: 1320670,
    favorites: 78120,
    rating: 9.4,
    chapters: [
      { id: "c2-1", number: 1, title: "入长安", updatedAt: "2026-07-15" },
      { id: "c2-2", number: 2, title: "雨夜试剑", updatedAt: "2026-07-22" },
      { id: "c2-3", number: 3, title: "醉仙楼", updatedAt: "2026-07-29" },
      { id: "c2-4", number: 4, title: "师门的信", updatedAt: "2026-08-05" },
      { id: "c2-5", number: 5, title: "剑影重重", updatedAt: "2026-08-12" },
      { id: "c2-6", number: 6, title: "朝堂暗涌", updatedAt: "2026-08-19" },
      { id: "c2-7", number: 7, title: "断刃之约", updatedAt: "2026-08-26" },
      { id: "c2-8", number: 8, title: "长安刀客", updatedAt: "2026-09-02" },
      { id: "c2-9", number: 9, title: "宫墙之上", updatedAt: "2026-09-16" },
      { id: "c2-10", number: 10, title: "剑舞长安", updatedAt: "2026-10-11" },
    ],
  },
  {
    id: "3",
    title: "月下花语",
    author: "苏晚晴",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20shojo%20comic%20book%20cover%20illustration%20of%20a%20gentle%20girl%20in%20a%20pastel%20dress%20holding%20a%20bouquet%20under%20a%20full%20moon%20surrounded%20by%20glowing%20flower%20petals%2C%20soft%20dreamy%20night%20garden%20with%20warm%20lantern%20glow%2C%20romantic%20delicate%20lighting%2C%20highly%20detailed%20elegant%20manga%20art%2C%20clean%20centered%20composition&width=600&height=800&seq=jm-cover-03&orientation=portrait",
    genres: ["少女", "恋爱"],
    status: "completed",
    description:
      "转学而来的少女柳月，在开满夜来香的小镇遇见沉默寡言的花店少年。一段始于花语、终于月下的青春物语，温柔地讲述着喜欢一个人时最笨拙也最动人的模样。",
    updatedAt: "2026-06-20",
    views: 987340,
    favorites: 65300,
    rating: 9.3,
    chapters: [
      { id: "c3-1", number: 1, title: "转学第一天", updatedAt: "2026-04-06" },
      { id: "c3-2", number: 2, title: "夜来香花店", updatedAt: "2026-04-13" },
      { id: "c3-3", number: 3, title: "花语", updatedAt: "2026-04-20" },
      { id: "c3-4", number: 4, title: "雨天共伞", updatedAt: "2026-04-27" },
      { id: "c3-5", number: 5, title: "心事重重", updatedAt: "2026-05-04" },
      { id: "c3-6", number: 6, title: "夏祭的约定", updatedAt: "2026-05-18" },
      { id: "c3-7", number: 7, title: "来不及说", updatedAt: "2026-06-01" },
      { id: "c3-8", number: 8, title: "月下花语", updatedAt: "2026-06-20" },
    ],
  },
  {
    id: "4",
    title: "机械之心",
    author: "陈默",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20sci-fi%20anime%20comic%20book%20cover%20illustration%20of%20a%20female%20android%20with%20flowing%20silver%20hair%20and%20a%20glowing%20orange%20chest%20core%20surrounded%20by%20floating%20mechanical%20parts%2C%20futuristic%20dark%20laboratory%20with%20teal%20and%20amber%20cables%2C%20moody%20low%20key%20lighting%20with%20strong%20contrast%2C%20highly%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-04&orientation=portrait",
    genres: ["青年", "科幻"],
    status: "serializing",
    description:
      "在这座由算法统治的都市里，维修师阿澈意外唤醒了编号 RM-07 的旧型仿生人。当冰冷的钢铁开始有了心跳，人类与机器的界限也在一次次抉择中悄然模糊。",
    updatedAt: "2026-10-13",
    views: 1120480,
    favorites: 70240,
    rating: 9.5,
    chapters: [
      { id: "c4-1", number: 1, title: "废料场的苏醒", updatedAt: "2026-07-10" },
      { id: "c4-2", number: 2, title: "编号 RM-07", updatedAt: "2026-07-17" },
      { id: "c4-3", number: 3, title: "第一次心跳", updatedAt: "2026-07-24" },
      { id: "c4-4", number: 4, title: "算法之城", updatedAt: "2026-07-31" },
      { id: "c4-5", number: 5, title: "记忆碎片", updatedAt: "2026-08-07" },
      { id: "c4-6", number: 6, title: "追捕令", updatedAt: "2026-08-14" },
      { id: "c4-7", number: 7, title: "地下诊所", updatedAt: "2026-08-21" },
      { id: "c4-8", number: 8, title: "钢铁的眼泪", updatedAt: "2026-09-04" },
      { id: "c4-9", number: 9, title: "核心协议", updatedAt: "2026-09-18" },
      { id: "c4-10", number: 10, title: "机械之心", updatedAt: "2026-10-02" },
      { id: "c4-11", number: 11, title: "重写命运", updatedAt: "2026-10-13" },
    ],
  },
  {
    id: "5",
    title: "幻境之城的守护者",
    author: "夏川",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20fantasy%20anime%20comic%20book%20cover%20illustration%20of%20a%20young%20guardian%20holding%20a%20glowing%20crystal%20staff%20before%20a%20floating%20magical%20city%20of%20towers%20and%20waterfalls%2C%20dramatic%20twilight%20sky%20with%20warm%20orange%20and%20deep%20charcoal%20tones%2C%20epic%20cinematic%20lighting%2C%20highly%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-05&orientation=portrait",
    genres: ["奇幻", "少年"],
    status: "completed",
    description:
      "幻境之城每隔百年便会被迷雾吞噬一次。见习守护者凛在成人礼那天接过了碎成七块的守护水晶，为了守护这座城与城中的人，她必须踏上集齐水晶碎片的试炼之路。",
    updatedAt: "2026-05-30",
    views: 856210,
    favorites: 54110,
    rating: 9.2,
    chapters: [
      { id: "c5-1", number: 1, title: "成人礼", updatedAt: "2026-03-01" },
      { id: "c5-2", number: 2, title: "碎裂的水晶", updatedAt: "2026-03-08" },
      { id: "c5-3", number: 3, title: "迷雾森林", updatedAt: "2026-03-15" },
      { id: "c5-4", number: 4, title: "第一块碎片", updatedAt: "2026-03-29" },
      { id: "c5-5", number: 5, title: "守护者的试炼", updatedAt: "2026-04-12" },
      { id: "c5-6", number: 6, title: "天空回廊", updatedAt: "2026-04-26" },
      { id: "c5-7", number: 7, title: "百年之约", updatedAt: "2026-05-10" },
      { id: "c5-8", number: 8, title: "最后的碎片", updatedAt: "2026-05-24" },
      { id: "c5-9", number: 9, title: "幻境之城", updatedAt: "2026-05-30" },
    ],
  },
  {
    id: "6",
    title: "青春告白练习曲",
    author: "顾念",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20romance%20anime%20comic%20book%20cover%20illustration%20of%20two%20high%20school%20students%20in%20uniforms%20sharing%20earphones%20under%20warm%20afternoon%20sunlight%2C%20school%20rooftop%20with%20soft%20sky%2C%20warm%20orange%20glow%20and%20gentle%20bokeh%2C%20nostalgic%20youthful%20atmosphere%2C%20highly%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-06&orientation=portrait",
    genres: ["恋爱", "少女"],
    status: "serializing",
    description:
      "总是把告白稿写了又撕的少女夏栀，遇见了比她更不会表达心意的转校生周野。一个关于练习告白、也关于学会坦诚的青春故事，在蝉鸣与晚自习之间悄悄展开。",
    updatedAt: "2026-10-10",
    views: 764320,
    favorites: 48870,
    rating: 9.1,
    chapters: [
      { id: "c6-1", number: 1, title: "写不完的告白信", updatedAt: "2026-08-08" },
      { id: "c6-2", number: 2, title: "转校生周野", updatedAt: "2026-08-15" },
      { id: "c6-3", number: 3, title: "练习对象", updatedAt: "2026-08-22" },
      { id: "c6-4", number: 4, title: "天台上的风", updatedAt: "2026-08-29" },
      { id: "c6-5", number: 5, title: "运动会那天", updatedAt: "2026-09-12" },
      { id: "c6-6", number: 6, title: "心跳的节拍", updatedAt: "2026-09-26" },
      { id: "c6-7", number: 7, title: "雨中的告白", updatedAt: "2026-10-03" },
      { id: "c6-8", number: 8, title: "练习曲的终章", updatedAt: "2026-10-10" },
    ],
  },
  {
    id: "7",
    title: "暗影猎人",
    author: "陆沉",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20dark%20action%20anime%20comic%20book%20cover%20illustration%20of%20a%20hooded%20hunter%20with%20glowing%20amber%20eyes%20holding%20twin%20blades%20amid%20swirling%20shadow%20mist%2C%20moody%20night%20city%20alley%20with%20warm%20street%20light%2C%20dramatic%20high%20contrast%20lighting%2C%20highly%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-07&orientation=portrait",
    genres: ["动作", "青年"],
    status: "serializing",
    description:
      "在人类看不见的阴影里，猎人组织世代隐匿守护着城市的平衡。年轻猎人沈砚继承了一柄能斩断暗影的猎刃，却在追猎途中发现，最危险的怪物或许来自人心深处。",
    updatedAt: "2026-10-13",
    views: 1441920,
    favorites: 83960,
    rating: 9.5,
    chapters: [
      { id: "c7-1", number: 1, title: "阴影之中", updatedAt: "2026-06-05" },
      { id: "c7-2", number: 2, title: "猎刃传承", updatedAt: "2026-06-12" },
      { id: "c7-3", number: 3, title: "第一只暗影", updatedAt: "2026-06-19" },
      { id: "c7-4", number: 4, title: "午夜追踪", updatedAt: "2026-06-26" },
      { id: "c7-5", number: 5, title: "猎人组织", updatedAt: "2026-07-03" },
      { id: "c7-6", number: 6, title: "背叛者", updatedAt: "2026-07-17" },
      { id: "c7-7", number: 7, title: "深渊回响", updatedAt: "2026-07-31" },
      { id: "c7-8", number: 8, title: "血脉之谜", updatedAt: "2026-08-14" },
      { id: "c7-9", number: 9, title: "猎人与猎物", updatedAt: "2026-08-28" },
      { id: "c7-10", number: 10, title: "黎明之前", updatedAt: "2026-09-18" },
      { id: "c7-11", number: 11, title: "暗影王座", updatedAt: "2026-10-06" },
      { id: "c7-12", number: 12, title: "最后的猎杀", updatedAt: "2026-10-13" },
    ],
  },
  {
    id: "8",
    title: "龙裔传说",
    author: "白泽",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20epic%20fantasy%20anime%20comic%20book%20cover%20illustration%20of%20a%20young%20dragon%20knight%20with%20glowing%20golden%20eyes%20raising%20a%20great%20spear%20against%20a%20colossal%20shadow%20dragon%2C%20stormy%20dark%20mountain%20landscape%20with%20lightning%2C%20dramatic%20amber%20and%20deep%20charcoal%20palette%2C%20epic%20cinematic%20lighting%2C%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-08&orientation=portrait",
    genres: ["奇幻", "少年"],
    status: "completed",
    description:
      "被世人畏惧的龙裔血脉在少年伊格身上觉醒，火焰顺着他的印记蔓延。为了证明血脉不是诅咒，他踏上屠龙与自我救赎的旅途，去寻找传说中龙与人类共存的大陆尽头。",
    updatedAt: "2026-05-16",
    views: 1098760,
    favorites: 71020,
    rating: 9.4,
    chapters: [
      { id: "c8-1", number: 1, title: "觉醒之日", updatedAt: "2026-02-10" },
      { id: "c8-2", number: 2, title: "火焰印记", updatedAt: "2026-02-17" },
      { id: "c8-3", number: 3, title: "被驱逐的少年", updatedAt: "2026-02-24" },
      { id: "c8-4", number: 4, title: "龙语者", updatedAt: "2026-03-03" },
      { id: "c8-5", number: 5, title: "雪山试炼", updatedAt: "2026-03-17" },
      { id: "c8-6", number: 6, title: "远古契约", updatedAt: "2026-03-31" },
      { id: "c8-7", number: 7, title: "大陆尽头", updatedAt: "2026-04-14" },
      { id: "c8-8", number: 8, title: "龙与人类", updatedAt: "2026-04-28" },
      { id: "c8-9", number: 9, title: "血脉的真相", updatedAt: "2026-05-12" },
      { id: "c8-10", number: 10, title: "龙裔传说", updatedAt: "2026-05-16" },
    ],
  },
  {
    id: "9",
    title: "都市灵异录",
    author: "夜羽",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20supernatural%20anime%20comic%20book%20cover%20illustration%20of%20a%20young%20exorcist%20holding%20a%20glowing%20paper%20talisman%20before%20a%20faint%20spirit%20in%20a%20rainy%20city%20street%20at%20night%2C%20warm%20neon%20reflections%20on%20wet%20asphalt%2C%20moody%20atmospheric%20lighting%2C%20highly%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-09&orientation=portrait",
    genres: ["青年", "同人"],
    status: "serializing",
    description:
      "在钢筋水泥的都市褶皱里，潜伏着人们不愿相信的灵异存在。半吊子除魔师陆平靠一张张符纸勉强糊口，却总在最不该心软的时候，对不该同情的存在伸出援手。",
    updatedAt: "2026-10-09",
    views: 623480,
    favorites: 39910,
    rating: 9.0,
    chapters: [
      { id: "c9-1", number: 1, title: "子时来电", updatedAt: "2026-08-01" },
      { id: "c9-2", number: 2, title: "符纸不够用了", updatedAt: "2026-08-08" },
      { id: "c9-3", number: 3, title: "地铁末班车", updatedAt: "2026-08-15" },
      { id: "c9-4", number: 4, title: "老宅的秘密", updatedAt: "2026-08-29" },
      { id: "c9-5", number: 5, title: "温柔的鬼", updatedAt: "2026-09-12" },
      { id: "c9-6", number: 6, title: "同行的前辈", updatedAt: "2026-09-19" },
      { id: "c9-7", number: 7, title: "午夜医院", updatedAt: "2026-09-26" },
      { id: "c9-8", number: 8, title: "因果line", updatedAt: "2026-10-03" },
      { id: "c9-9", number: 9, title: "都市灵异录", updatedAt: "2026-10-09" },
    ],
  },
  {
    id: "10",
    title: "花开半夏",
    author: "温言",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20sweet%20romance%20anime%20comic%20book%20cover%20illustration%20of%20a%20girl%20in%20a%20summer%20dress%20running%20through%20a%20field%20of%20blooming%20sunflowers%20under%20bright%20warm%20sunlight%2C%20soft%20orange%20and%20cream%20tones%2C%20nostalgic%20youthful%20atmosphere%2C%20highly%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-10&orientation=portrait",
    genres: ["少女", "恋爱"],
    status: "completed",
    description:
      "海边小镇的半夏，把整个夏天都借给了来度假的陌生少年。他们约定不谈将来，只谈当下，可当夏天结束，才发现有些相遇注定要留在花开正盛的时节里。",
    updatedAt: "2026-04-18",
    views: 542190,
    favorites: 36240,
    rating: 8.9,
    chapters: [
      { id: "c10-1", number: 1, title: "夏天来了", updatedAt: "2026-03-05" },
      { id: "c10-2", number: 2, title: "借你的夏天", updatedAt: "2026-03-12" },
      { id: "c10-3", number: 3, title: "向日葵田", updatedAt: "2026-03-19" },
      { id: "c10-4", number: 4, title: "海边的烟火", updatedAt: "2026-03-26" },
      { id: "c10-5", number: 5, title: "不说将来", updatedAt: "2026-04-02" },
      { id: "c10-6", number: 6, title: "夏天结束前", updatedAt: "2026-04-11" },
      { id: "c10-7", number: 7, title: "花开半夏", updatedAt: "2026-04-18" },
    ],
  },
  {
    id: "11",
    title: "星际拓荒者",
    author: "江野",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20sci-fi%20action%20anime%20comic%20book%20cover%20illustration%20of%20a%20rugged%20space%20pioneer%20in%20armored%20suit%20standing%20on%20an%20alien%20planet%20surface%20with%20a%20colossal%20terraforming%20machine%20behind%2C%20dusty%20orange%20desert%20sky%20and%20distant%20space%20station%2C%20dramatic%20cinematic%20lighting%2C%20detailed%20manga%20art&width=600&height=800&seq=jm-cover-11&orientation=portrait",
    genres: ["科幻", "动作"],
    status: "serializing",
    description:
      "当母星资源枯竭，一群拓荒者驾驶方舟驶向未知的边疆星系。地质工程师姜野带着团队降落在一颗陌生的荒漠星球，他们要在这里建立起人类新的家园，也要面对这片土地最原始的恶意。",
    updatedAt: "2026-10-08",
    views: 918760,
    favorites: 59430,
    rating: 9.3,
    chapters: [
      { id: "c11-1", number: 1, title: "方舟启航", updatedAt: "2026-07-05" },
      { id: "c11-2", number: 2, title: "陌生星球", updatedAt: "2026-07-12" },
      { id: "c11-3", number: 3, title: "第一场沙暴", updatedAt: "2026-07-19" },
      { id: "c11-4", number: 4, title: "地下水源", updatedAt: "2026-08-02" },
      { id: "c11-5", number: 5, title: "拓荒者营地", updatedAt: "2026-08-16" },
      { id: "c11-6", number: 6, title: "星球的恶意", updatedAt: "2026-08-30" },
      { id: "c11-7", number: 7, title: "遗迹信号", updatedAt: "2026-09-13" },
      { id: "c11-8", number: 8, title: "同胞还是敌人", updatedAt: "2026-09-20" },
      { id: "c11-9", number: 9, title: "大地之怒", updatedAt: "2026-09-30" },
      { id: "c11-10", number: 10, title: "新的家园", updatedAt: "2026-10-08" },
    ],
  },
  {
    id: "12",
    title: "神隐之森",
    author: "森见",
    cover: "https://readdy.ai/api/search-image?query=Vertical%20fantasy%20anime%20comic%20book%20cover%20illustration%20of%20a%20young%20girl%20standing%20at%20the%20edge%20of%20a%20mysterious%20ancient%20forest%20with%20glowing%20spirits%20floating%20between%20tall%20trees%2C%20dappled%20warm%20sunlight%20through%20leaves%2C%20misty%20dark%20greens%20with%20amber%20highlights%2C%20highly%20detailed%20stylized%20manga%20art&width=600&height=800&seq=jm-cover-12&orientation=portrait",
    genres: ["奇幻", "少女"],
    status: "serializing",
    description:
      "传说进入神隐之森的人会被山神藏起，再也不会回来。少女铃音为了寻找失踪的哥哥走进这片森林，遇见了自称守林人的狐面少年，也渐渐发现这座森林远比传说更加温柔而危险。",
    updatedAt: "2026-10-07",
    views: 702340,
    favorites: 45120,
    rating: 9.2,
    chapters: [
      { id: "c12-1", number: 1, title: "迷路的孩子", updatedAt: "2026-08-12" },
      { id: "c12-2", number: 2, title: "狐面少年", updatedAt: "2026-08-19" },
      { id: "c12-3", number: 3, title: "守林人的规矩", updatedAt: "2026-08-26" },
      { id: "c12-4", number: 4, title: "夜里的灯笼", updatedAt: "2026-09-02" },
      { id: "c12-5", number: 5, title: "哥哥的踪迹", updatedAt: "2026-09-09" },
      { id: "c12-6", number: 6, title: "山神的试炼", updatedAt: "2026-09-23" },
      { id: "c12-7", number: 7, title: "森林的秘密", updatedAt: "2026-09-30" },
      { id: "c12-8", number: 8, title: "神隐之森", updatedAt: "2026-10-07" },
    ],
  },
];

export const siteIntro = {
  name: "JMcomic2",
  slogan: "高清漫画，随时随地畅快阅读",
  paragraphs: [
    "JMcomic2 是一个专注于正版高清漫画在线阅读的平台，收录少年、少女、青年、同人、奇幻、科幻、恋爱、动作等多种题材的优质作品，服务每一位热爱漫画的读者。",
    "我们坚持高清画质与流畅阅读体验，持续更新最新章节，并提供便捷的更新提示，让追更不再错过任何精彩瞬间。",
    "所有示例内容仅用于平台功能演示，版权归原作者及出版方所有。",
  ],
};